import React, { useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { notificationActions } from '../../core/resource/actions';
import appConstants, { alertMap } from '../../utils/Constants.config'
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

function CustomToast(props) {
  const toast = useRef(null);
  const { navigateCloseSnackbar } = props;
  const { isOpenSnackbar, duration, messageText, alertType } = useSelector(state => state.notification);

  const showToast = () => {
    if(isOpenSnackbar && toast?.current)
      toast.current.show({
        severity: alertType || 'error',
        summary: '',
        detail: messageText, 
        life: duration || appConstants.defaultAlertDuration
      });
  }
  return (
    <div>
      <ToastContainer position="bottom-end">
      <Toast
           onClose={() => (navigateCloseSnackbar())}
            show={isOpenSnackbar}
            delay={duration}
            autohide
            bg={alertMap[alertType] ||''}
            style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Alert</strong>
          </Toast.Header>
            <Toast.Body className={'text-white'}>{messageText}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  navigateCloseSnackbar: () => dispatch(notificationActions.closeSnackbar()),
});

export default connect(
  null,
  mapDispatchToProps,
)(CustomToast);